import { updateLessonCompleted } from "@/services/lessonsService";
import {
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_SUCCESS_MESSAGE,
  ESTATUS_LEARNING,
  LessonDetailDto,
} from "@/types";
import { toastError, toastSuccess } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useLessonCompleted = (id: number) => {
  const queryClient = useQueryClient();
  const queryKey = ["lesson-detail", Number(id)];
  const markLessonCompleted = useMutation({
    mutationFn: () => {
      return updateLessonCompleted(id);
    },
    onMutate: async () => {
      //Hủy request đang chạy (nếu có) để tránh ghi đè data
      await queryClient.cancelQueries({ queryKey: queryKey });
      // Lấy dữ liệu hiện tại trong cache
      const prevData = queryClient.getQueryData(queryKey) as LessonDetailDto;
      // Optimistic update: cập nhật cache ngay lập tức
      if (prevData) {
        queryClient.setQueryData(queryKey, (old: LessonDetailDto) => {
          return {
            ...old,
            progress_status: ESTATUS_LEARNING.COMPLETED,
          };
        });
      }
      return { prevData };
    },
    onSuccess: (resp) => {
      toastSuccess(resp?.message || DEFAULT_SUCCESS_MESSAGE);
      queryClient.invalidateQueries({ queryKey: ["lesson-list"] });
      queryClient.invalidateQueries({ queryKey: ["unit-detail"] });
    },
    onError: (err: any, __, context) => {
      toastError(err?.message || DEFAULT_ERROR_MESSAGE);
      if (context?.prevData) {
        queryClient.setQueryData(queryKey, context.prevData);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: queryKey });
    },
  });

  return { markLessonCompleted };
};
